// Include jQuery plugins
require('jquery-match-height/dist/jquery.matchHeight-min.js');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global hp google handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Feedback page password modal
        */
        __passwordModal: () => {

            const passwordModal = wntrTheme.body.find('.passster-form');
            const main = wntrTheme.body.find('main');

            if(passwordModal.length) {

                passwordModal.find('h4:first').text('Det här innehållet är lösenordsskyddat');
                passwordModal.find('p:first').text('Vänligen ange ditt lösenord nedan för att visa innehåll:');
                passwordModal.find('#passster_password').attr("placeholder", "Lösenord..");
                passwordModal.find('.passster-submit').text('Gå vidare');

                if(!main.hasClass('isProtected')) {
                    main.addClass('isProtected');
                }

                $(passwordModal).on("hide", function() {
                    main.removeClass('isProtected');
                });

                const _oldhide = $.fn.hide;
                $.fn.hide = function() {
                    $(this).trigger('hide');
                    return _oldhide.apply(this, arguments);
                };
            }
        },


        /**
         * Removes element outline when using mouse
        */
        __initOutlineTabbing: () => {

            wntrTheme.body.addClass('outline-inactive');

            $('body').on('mousedown', () => {
                if(!$('body').hasClass('outline-inactive')) {
                    $('body').addClass('outline-inactive');
                }
            });

            $("body").on('keyup', function(e) {
                const keyCode = e.keyCode || e.which;
                if(keyCode === 9 && $('body').hasClass('outline-inactive')) {
                    $('body').removeClass('outline-inactive');
                }
            });
        },

        __initDynamicEmployeeFormSelect: () => {
            $('.gravityforms--Kontakt').find('.populate-case-management select').change(function() {

                const select = $('.gravityforms--Kontakt').find('.populate-employees select');
                const selectedCase = $('.gravityforms--Kontakt').find('.populate-case-management option:selected').text();
                const data = {
                    'action': 'handle_populate_form',
                    'case': selectedCase
                };

                $.ajax({
                    url: hp.ajax_url,
                    data: data,
                    type: 'POST',
                    beforeSend: function() {
                        $(select).closest("li").addClass('disabled');
                        $('.gravityforms--Kontakt').find('.populate-employees select').prop('selectedIndex', 0);
                    },
                    success: function(data) {
                        $('.gravityforms--Kontakt').find('.populate-employees option:first').text('Välj mottagare');
                        $('.gravityforms--Kontakt').find('.populate-employees option').hide();
                        $.each(JSON.parse(data), function(key, value) {
                            $('.gravityforms--Kontakt').find('.populate-employees option:contains("' + value + '")').show();
                        });

                        $(select).closest("li").removeClass('disabled');
                    }
                });
            });
        },

        /**
         * Init accordions
         */
        __initAccordions: () => {
            if(wntrTheme.body.find('.handorgel').length > 0) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
         * jQuery MatchHeight
         */
        __doMatchHeight: function() {
            wntrTheme.body.find('.facebook__post-content p').matchHeight();
            wntrTheme.body.find('.case-card__links').matchHeight();
        },

        __onFacetSort: () => {
            const referenceWrapper = wntrTheme.body.find('.references__wrapper');
            $(document).on('facetwp-refresh', function() {
                referenceWrapper.addClass('is-loading');
            });
            $(document).on('facetwp-loaded', function() {
                referenceWrapper.removeClass('is-loading');
            });
        },

        /**
         * Relevanssi search handler
         */
        __toggleSearch: () => {

            const searchDesktop = wntrTheme.body.find('.header__search-wrapper--desktop');
            const searchInput = wntrTheme.body.find('.header__search-input');
            const searchInputDesktop = $(searchDesktop).find('.header__search-input');
            const searchForm = wntrTheme.body.find('.header__search-form');
            const searchBar = wntrTheme.body.find('.header__search-bar');

            wntrTheme.body.find('.header__search-button').on('click', (e) => {
                e.preventDefault();
                if(!searchBar.hasClass('is-active')) {
                    searchBar.addClass('is-active');
                    searchInput.css('pointer-events', '');
                    $('html,body').animate({ scrollTop: $(searchInputDesktop).offset().top - 25 }, 200);
                    $(searchInput).focus();
                }
            });

            searchInput.on('keyup', (e) => {
                if(e.which === 13 && searchForm.valid()) {
                    $(searchForm).submit();
                }
            });

            searchInput.on('focusout', () => {
                // focusout seems to be faster than form submit
                setTimeout(() => {
                    if(searchBar.hasClass('is-active')) {
                        searchBar.removeClass('is-active');
                    }
                }, 120);
            });
        },

        /**
         * Slick slider
         */
        __initSlickSlider: function() {

            const employeeWrapper = $('.employees__employees-wrapper');

            const settings = {
                dots: true,
                infinite: false,
                speed: 300,
                arrows: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            };

            employeeWrapper.slick(settings);

            $(window).on('resize', function() {

                if($(window).width() <= 1009 && !employeeWrapper.hasClass('slick-initialized')) {
                    employeeWrapper.slick(settings);
                }

            });
        },

        /**
         * Google Maps
        */
        __initGoogleMaps: () => {
            const map = wntrTheme.body.find('.contact-form__map');
            const latitude = parseFloat(map.data('latitude'));
            const longitude = parseFloat(map.data('longitude'));
            const address = map.data('address');
            const mapsURL = map.data('mapslink');
            if(map.length) {

                let zoom = 11;

                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    zoom = 12;
                }

                const mapObject = new google.maps.Map(document.getElementById('map'), {
                    zoom: zoom,
                    disableDefaultUI: true,
                    center: new google.maps.LatLng(latitude, longitude),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    gestureHandling: 'cooperative',
                    styles: [
                        {
                            "featureType": "landscape",
                            "stylers": [
                                {
                                    "color": "#eff6f6"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#d3ebe7"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "stylers": [
                                {
                                    "color": "#b6d4ef"
                                }
                            ]
                        }
                    ]
                });

                const icon = {
                    url: hp.directory_url + '/src/images/marker.svg',
                    size: new google.maps.Size(40, 40), scaledSize: new google.maps.Size(40, 40)
                };

                const infowindow = new google.maps.InfoWindow({
                    content: '<div class="marker"><h2 class="marker__title heading-3">HP Kyla & värme</h2><a href="' + mapsURL + '"target="_blank" rel="noopener norefferer" class="marker__link">' + address + '</a></div>'
                });

                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(latitude, longitude),
                    animation: google.maps.Animation.DROP,
                    icon: icon,
                    map: mapObject
                });

                marker.addListener('click', function() {
                    infowindow.open(map, marker);
                });


            }
        },

        /**
         * Toggle contact button
         */
        __toggleContact: () => {
            const contacts = wntrTheme.body.find('.contact-form__contacts');
            wntrTheme.body.find('.contact-form__toggle').on('click', (e) => {
                if($(contacts).hasClass("is-active")) {
                    $(contacts).animate({ "height": "23rem" }).removeClass("is-active");
                } else {
                    $(contacts).animate({ "height": "60rem" }).addClass("is-active");
                }
                $(e.currentTarget).toggleClass('is-active');
            });
        },

        /**
         * Toggle header
         */
        __toggleHeader: () => {
            // Toggle main header
            const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');

            toggleHeaderButton.on('click', function() {
                if(wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('body--fixed');
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    $(this).removeClass('is-active');
                    wntrTheme.document.scrollTop(wntrTheme.current_position);
                } else {
                    wntrTheme.body.addClass('header--mobile-menu-active');
                    $(this).addClass('is-active');

                    // Save current position from top
                    wntrTheme.current_position = wntrTheme.document.scrollTop();
                    // SetTimeout till the css animation has ended
                    setTimeout(function() {
                        wntrTheme.body.addClass('body--fixed');
                    }, 200);
                }
            });

            $(document).keyup(function(e) {
                if(e.keyCode === 27 && wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    wntrTheme.body.removeClass('body--fixed');
                }
            });

            // Toggle sub menu
            if($(window).width() < 1100) {
                const toggleSubMenuButton = wntrTheme.body.find('.header__toggle-sub-menu');

                toggleSubMenuButton.on('click', function() {
                    const btn = $(this);
                    btn.toggleClass('is--active');
                    btn.closest('.menu-item-has-children').find('.sub-menu').slideToggle('fast');
                });

                // Check if we're on an subpage
                const active_sub_menu = wntrTheme.body.find('li.active .sub-menu');
                if(active_sub_menu.length > 0) {
                    active_sub_menu.closest('.menu-item-has-children').find('.header__toggle-sub-menu').addClass('is--active');
                    active_sub_menu.css('display', 'block');
                }
            } else {
                const hover_submenu_item = wntrTheme.body.find('li.menu-item-has-children');
                wntrTheme.body.find('.header__toggle-sub-menu').attr('tabindex', '-1');

                hover_submenu_item.on('mouseover', function() {
                    $(this).find('.sub-menu').addClass('is-active');
                    //wntrTheme.body.addClass($(this).closest('nav').attr('class') + '--active');
                });

                hover_submenu_item.on('mouseout', function() {
                    $(this).find('.sub-menu').removeClass('is-active');
                    // wntrTheme.body.removeClass($(this).closest('nav').attr('class') + '--active');
                });

                hover_submenu_item.find('a').on('focus', function() {
                    $(this).parent().find('.sub-menu').addClass('is-active');
                });

                hover_submenu_item.focusout(function() {
                    $(this).removeClass('is-active');
                });

                hover_submenu_item.find('.sub-menu li:last-of-type > a').focusout(function() {
                    wntrTheme.body.find('.sub-menu').removeClass('is-active');
                });

                wntrTheme.body.on('click', function() {
                    wntrTheme.body.find('.sub-menu').removeClass('is-active');
                });
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);